import { render, staticRenderFns } from "./move.vue?vue&type=template&id=376b0386&scoped=true"
import script from "./move.vue?vue&type=script&lang=js"
export * from "./move.vue?vue&type=script&lang=js"
import style0 from "./move.vue?vue&type=style&index=0&id=376b0386&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b0386",
  null
  
)

export default component.exports